/* eslint-disable react/no-deprecated */

/**
 * We are disabling the react/no-deprecated,
 * because the bellowing code is used in integration,
 * and we are not ready yet to upgrade to ES 6 syntax.
 */

import React from 'react';
import PT from 'prop-types';
import up from 'react-addons-update';
import tsRest from 'ts-rest-client';
import TranslatorManager from 'ts-translate-js';
import { Button, Dropdown, Textbox, ResponsivenessGrid, Checkbox } from '../toolkit';
import { WaitSpinners } from 'ts-common-react-controls';
import { map, keys, includes, filter, size, concat } from 'lodash';

const tr = TranslatorManager.boundTR;

const producerMandatoryFields = [ "FirstName", "LastName", "Email", "Phone", "Province" ];

export class SellYourTicketsWithUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            missingFields: [],
            processing: false,
            eventToProduceInfos: this.getEmptyEventToProduceInfos(),
            refreshSize: false
        };
    }


    getEmptyEventToProduceInfos() {
        return {
            CompagnyName: "",
            FirstName: "",
            LastName: "",
            Email: "",
            Phone: "",
            Province: "",
            Title: "",
            HaveEventInfos: false,
            Event: {
                EventName: "",
                VenueName: "",
                VenueCity: "",
                VenueProvince: "",
                VenuePostalCode: "",
                VenueCapacity: "",
                AdultTicketsPrice: "",
                KidTicketsPrice: "",
            },
            SalesDate: "",
            RepresentationNumber: "",
            EventDate: "",
            EventProduceInYear: "",
            EstimatedPreSale: "",
            TicketsType: "adm.gen.",
            Referenced: "",
            Comments: ""
        };
    }
    
    handleClear() {
        this.setState({ eventToProduceInfos: this.getEmptyEventToProduceInfos(), missingFields: [] });
    }

    getFormMissingFields() {
        return filter(keys(this.state.eventToProduceInfos), info => {
            if (includes(producerMandatoryFields, info) && (
                (this.state.eventToProduceInfos[info] == undefined || this.state.eventToProduceInfos[info] === "")))
                return info;
        });
    }

    handleSend() {
        const missingFields = this.getFormMissingFields();
        this.setState({ missingFields });
        if (size(missingFields) === 0)
            this.onCompleteSave();
    }

    async onCompleteSave() {
        this.setState({ processing: true });
        
        try {
            await tsRest.post("/contactus/rese/sellyourtickets", this.state.eventToProduceInfos);
            this.setState({ processing: false });
            window.location.href = this.props.homeUrl;
        }
        catch (err) {
            this.setState({ ts: null, processing: false });
            return tsRest.handleError(err);
        }
    }

    handleOnInfoChange(eventToProduceInfos) {
        
        this.setState({ eventToProduceInfos, refreshSize: true });
    }

    render() {
        let eventInfo = null;

        if (this.state.eventToProduceInfos.HaveEventInfos) { //I have not been able to give a real true or false by the select
            eventInfo = <div key="venue">
                <EventInformation
                    onInfoChange={this.handleOnInfoChange.bind(this)} 
                    eventToProduceInfos={this.state.eventToProduceInfos} 
                />
            </div>;
        }

        let error;
        if (size(this.state.missingFields) > 0) {
            error = <div>
                <div className="spacer-row" />
                <div className="form-group">
                    <div className="alert alert-danger text-center" role="alert">{tr("Les champs en rouge sont obligatoires")}</div>
                </div>
            </div>;
        }

        let content;
        if (this.state.processing)
            content = <WaitSpinners.PleaseWaitSpinner size="md" integ="rese" />;
        else {
            let infosCtl = [
                <div key="producer">
                    <ProducerInformation 
                        onInfoChange={this.handleOnInfoChange.bind(this)} 
                        eventToProduceInfos={this.state.eventToProduceInfos} 
                        missingFields={this.state.missingFields}
                    />
                </div>
            ];

            
            let numberOfColumn = 1;
            if(this.state.eventToProduceInfos.HaveEventInfos) {
                infosCtl = concat(infosCtl, eventInfo);
                numberOfColumn = 2;
            }
            
            content = <div>
                <ResponsivenessGrid currentBreakpoint={this.state.currentBreakpoint}
                                    refreshSize={this.state.refreshSize}
                                    nbrColumnsByBreakpointConfigs={{ mobile: 1, tablet: 1, small: numberOfColumn, large: numberOfColumn }}
                                    items={infosCtl}
                />
                {error}
                <div className="spacer-row" />
                <div className="pull-right">
                    <Button isSmall={true} onButtonClicked={this.handleClear.bind(this)}>
                        <span>{tr("Vider")}</span>
                    </Button>
                    <Button isSmall={true} useLeftMargin={true} onButtonClicked={this.handleSend.bind(this)}>
                        <span>{tr("Envoyer")}</span>
                    </Button>
                </div>
                <div style={{clear: "both"}}></div>
            </div>;
        }
        
        return <div className="sellYourTickets" style={(!this.state.eventToProduceInfos.HaveEventInfos ? {margin: "0 auto", maxWidth: "900px"} : {width: "100%"})}>
            <h2>{tr("Vendre un événement sur notre réseau")}</h2>
            <div className="smaller-spacer-row" />
            {content}
        </div>;
    }
}
SellYourTicketsWithUs.propTypes = {
    homeUrl: PT.string
};

export class ProducerInformation extends React.Component {
    handleOnChange(name, value) {
        this.props.onInfoChange(up(this.props.eventToProduceInfos, { [name]: { $set: value } }));
    }

    handleOnInputChange(name, value) {
        this.handleOnChange(name, value);
    }

    handleOnBoolSelectChange(name) {
        const boolValue = this.props.eventToProduceInfos[name];
        this.handleOnChange(name, !boolValue);
    }

    isMissingField(field) {
        return includes(this.props.missingFields, field);
    }

    render() {
        return (
            <div>
                <h3>{tr("Vos Informations")}</h3>
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Nom de la compagnie")}
                    onChange={this.handleOnInputChange.bind(this, "CompagnyName")}
                    value={this.props.eventToProduceInfos.CompagnyName}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Prénom")}
                    onChange={this.handleOnInputChange.bind(this, "FirstName")}
                    value={this.props.eventToProduceInfos.FirstName}
                    isLarger={true}
                    isInvalid={this.isMissingField("FirstName")}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Nom de famille")}
                    onChange={this.handleOnInputChange.bind(this, "LastName")}
                    value={this.props.eventToProduceInfos.LastName}
                    isLarger={true}
                    isInvalid={this.isMissingField("LastName")}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Titre")}
                    onChange={this.handleOnInputChange.bind(this, "Title")}
                    value={this.props.eventToProduceInfos.Title}
                    isLarger={true}
                    isInvalid={this.isMissingField("Title")}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Courriel")}
                    onChange={this.handleOnInputChange.bind(this, "Email")}
                    value={this.props.eventToProduceInfos.Email}
                    isLarger={true}
                    isInvalid={this.isMissingField("Email")}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Téléphone")}
                    onChange={this.handleOnInputChange.bind(this, "Phone")}
                    value={this.props.eventToProduceInfos.Phone}
                    isLarger={true}
                    isInvalid={this.isMissingField("Phone")}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Province")}
                    onChange={this.handleOnInputChange.bind(this, "Province")}
                    value={this.props.eventToProduceInfos.Province}
                    isLarger={true}
                    isInvalid={this.isMissingField("Province")}
                />
                <div className="smaller-spacer-row" />
                <Checkbox
                    id="venue-information-available"
                    label={tr("J'ai les informations de l'événement")}
                    onCheck={this.handleOnBoolSelectChange.bind(this, "HaveEventInfos")}
                    checked={this.props.eventToProduceInfos.HaveEventInfos}
                />
            </div>
        );
    }
}
ProducerInformation.propTypes = {
    onInfoChange: PT.func,
    eventToProduceInfos: PT.object,
    displaySize: PT.string,
    missingFields: PT.arrayOf(PT.string)
};

export class EventInformation extends React.Component {
    handleOnChange(name, value) {
        this.props.onInfoChange(up(this.props.eventToProduceInfos, { [name]: { $set: value } }));
    }

    handleOnEventChange(name, value) {
        let eventInfo = up(this.props.eventToProduceInfos.Event, { [name]: { $set: value } });
        this.props.onInfoChange(up(this.props.eventToProduceInfos, { "Event": { $set: eventInfo } }));
    }

    render() {
        const ticketTypes = [tr("Admission générale"), tr("Sièges réservés"), tr("Les deux")];
        return (
            <div>
                <h3>{tr("Informations à propos de votre événement")}</h3>
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Nom de la salle")}
                    onChange={this.handleOnEventChange.bind(this, "VenueName")}
                    value={this.props.eventToProduceInfos.Event.VenueName}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Ville de la salle")}
                    onChange={this.handleOnEventChange.bind(this, "VenueCity")}
                    value={this.props.eventToProduceInfos.Event.VenueCity}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Province")}
                    onChange={this.handleOnEventChange.bind(this, "VenueProvince")}
                    value={this.props.eventToProduceInfos.Event.VenueProvince}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Capacité de la salle")}
                    onChange={this.handleOnEventChange.bind(this, "VenueCapacity")}
                    value={this.props.eventToProduceInfos.Event.VenueCapacity}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Nom de votre ou de vos événement(s) ?")}
                    onChange={this.handleOnEventChange.bind(this, "EventName")}
                    value={this.props.eventToProduceInfos.Event.EventName}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Quand prévoyez-vous la mise en vente publique ?")}
                    onChange={this.handleOnChange.bind(this, "SalesDate")}
                    value={this.props.eventToProduceInfos.SalesDate}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Combien de représentations avez-vous planifiées ?")}
                    onChange={this.handleOnChange.bind(this, "RepresentationNumber")}
                    value={this.props.eventToProduceInfos.RepresentationNumber}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Date de la première représentation")}
                    onChange={this.handleOnChange.bind(this, "EventDate")}
                    value={this.props.eventToProduceInfos.EventDate}
                    isLarger={true}
                />
                <div className="spacer-row" />
                <label>{tr("Quel est le prix des billets ?")}</label>
                <div className="smaller-spacer-row" />
                <ResponsivenessGrid 
                    nbrColumnsByBreakpointConfigs={{ mobile: 2, tablet: 2, small: 2, large: 2 }}
                    items={[
                        <div key="adult-price">
                            <Textbox
                                placeholder={tr("Adulte")}
                                onChange={this.handleOnEventChange.bind(this, "AdultTicketsPrice")}
                                value={this.props.eventToProduceInfos.Event.AdultTicketsPrice}
                                isLarger={true}
                            />
                        </div>,
                        <div key="kid-price">
                            <Textbox
                                placeholder={tr("Enfant")}
                                onChange={this.handleOnEventChange.bind(this, "KidTicketsPrice")}
                                value={this.props.eventToProduceInfos.Event.KidTicketsPrice}
                                isLarger={true}
                            />
                        </div>
                    ]}
                />
                <div className="smaller-spacer-row" />
                <Dropdown
                    placeholder={tr("Quel est le type de billet ?")}
                    items={map(ticketTypes, t => ({
                        key: t,
                        name: t
                    }))}
                    valueField="key" textField="name"
                    onChange={this.handleOnChange.bind(this, "TicketsType")}
                    isFullWidth={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Le cas échéant, qui vous a référé ?")}
                    onChange={this.handleOnChange.bind(this, "Referenced")}
                    value={this.props.eventToProduceInfos.Referenced}
                    isLarger={true}
                />
                <div className="smaller-spacer-row" />
                <Textbox
                    placeholder={tr("Commentaires")}
                    onChange={this.handleOnChange.bind(this, "Comments")}
                    value={this.props.eventToProduceInfos.Comments}
                    isLarger={true}
                />
            </div>
        );
    }
}
EventInformation.propTypes = {
    onInfoChange: PT.func,
    eventToProduceInfos: PT.object,
};
